const SET_TABS = (state, tabs) => {
  state.tabs = tabs;
  if (tabs.length === 1) {
    state.activeTab = tabs[0].name;
  }
};

const SET_ACTIVE_TAB = (state, tab) => {
  state.activeTab = tab;
};

export default {
  SET_TABS,
  SET_ACTIVE_TAB
};
